import { DivIcon as LeafletDivIcon } from "leaflet";

const DivIcon = LeafletDivIcon.extend({
  createIcon: function(oldIcon) {
    const div = LeafletDivIcon.prototype.createIcon.call(this, oldIcon);

    if (this.options.style) {
      for (var key in this.options.style) {
        div.style[key] = this.options.style[key];
      }
    }

    return div;
  },
});

export default DivIcon;
